import { useRef } from 'react';
import { Tooltip } from 'react-tooltip';
import styled from 'styled-components';

export const IconSelectInput = ({
  value,
  defaultValue,
  data,
  onChange,
  label,
  iconClassName,
  style,
}: {
  value?: string | number | null;
  defaultValue?: string | number;
  data: {
    value?: string | number;
    iconClassName: string;
    iconStyle?: React.CSSProperties;
    id?: string;
    tooltip?: string;
  }[];
  onChange: (newValue?: string | number) => void;
  label?: string;
  iconClassName?: string;
  style?: React.CSSProperties;
}) => {
  const ref = useRef<HTMLInputElement>(null);

  const isTogglable = data.length === 1;

  return (
    <Container style={style}>
      {(label || iconClassName) && (
        <Label onClick={() => ref.current?.focus()}>
          {iconClassName && <i className={iconClassName} />}
          {label}
        </Label>
      )}

      <IconsContainer>
        {data.map((item) => (
          <IconButton
            key={item.id || '' + item.value}
            id={item.id}
            $isActive={value === null ? false : item.value === (value || defaultValue)}
            onClick={() => onChange(isTogglable ? (value === undefined ? item.value : undefined) : item.value)}
          >
            <i className={item.iconClassName} style={item.iconStyle} />
          </IconButton>
        ))}
        {data.map((item) =>
          item.tooltip && item.id ? (
            <Tooltip
              key={item.id || '' + item.value + '-tooltip'}
              anchorSelect={`#${item.id}`}
              place="bottom"
              content={item.tooltip}
              delayShow={1000}
            />
          ) : null
        )}
      </IconsContainer>
    </Container>
  );
};

const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 2px;

  border-radius: var(--radius-2);

  display: flex;
  justify-content: space-between;
`;

const Label = styled.label`
  padding-right: 5px;

  color: var(--main-2);
  font-family: var(--font-2);
  font-size: 13px;
  white-space: nowrap;

  display: flex;
  align-items: center;

  i {
    width: 20px;
    font-size: 19px;
    translate: -2px 0;
  }
`;

const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const IconButton = styled.div<{ $isActive?: boolean }>`
  box-sizing: border-box;
  cursor: pointer;
  width: 25px;
  height: 25px;
  border: 1px solid var(--neutral-3);
  border-radius: var(--radius-2);
  background-color: var(--neutral-2);

  font-size: 17px;
  color: var(--main-2);
  line-height: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    ${({ $isActive }) =>
      !$isActive &&
      `
      background-color: var(--neutral-3);
      color: var(--main-1);
    `}
  }

  ${({ $isActive }) => $isActive && `color: var(--primary-1); border-color: var(--primary-1); cursor: default;`}

  ${({ $isActive }) =>
    $isActive && `color: var(--primary-1); background-color: var(--neutral-1); border-color: transparent;`}

  transition: background-color var(--transition-2), color var(--transition-2), border-color var(--transition-2);
`;
